import React from 'react';
import { Link } from 'react-router-dom';
import wlogo from '../../../images/full-white.png';
import './Footer.css';

const Footer = () => {
  return (
    <div className='footerbg'>
      <footer className="text-center text-lg-start">
        <section>
          <div className="container mt-0 text-center text-md-start pt-4">
            <div className="row mt-3">
              <div className="col-md-3 col-lg-6 col-xl-3 mx-auto">
                <h6 className="text-uppercase fw-bold mb-4 me-3">
                  <Link to="/"><img src={wlogo} width='100px' alt="" /></Link>
                </h6>
                <p className="text-justify">
                Green Lead is an environment and climate change education platform. We care about people and the planet. In the pursuit of a green world, we are leading through environmental education and offering sustainable solutions.
                </p>
              </div>
              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  Contact
                </h6>
                <p><i className="fas fa-home me-3"></i>Chattogram, Bangladesh</p>
                <p>
                  <a href="mailto:greenlead.global@gmail.com"><i className="fas fa-envelope me-3"></i>greenlead.global@gmail.com</a>
                </p>
                <p><i className="fas fa-phone me-3"></i>+ 01 234 567 88</p>
                <p><i className="fas fa-print me-3"></i>+ 01 234 567 89</p>
              </div>
            </div>
          </div>
        </section>
        <section className="d-flex justify-content-center fs-2 p-1" >
          <div className="footer-social-icon text-center">
            <a href="https://www.facebook.com/greenlead.global" className="me-4 text-reset fb">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com/lead_green" className="me-4 text-reset twt">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://instagram.com/greenlead.global" className="me-4 text-reset insta">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/green-lead" className="me-4 text-reset linkedin">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCl-zcXBIuzG2Hdu4Ah9-5NA" className="me-4 text-reset yt">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </section>
        <div className="text-center p-4" style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}>
          © 2021 Copyright:
          <span className="text-reset fw-bold "> Green Lead</span>
        </div>
      </footer>
    </div>
  );
};

export default Footer;